import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/antd/es/progress/index.js
// module id = 322
// module chunks = 0